export default {"src":"/_next/static/media/weDevelopIconArrow.aca9add0.svg","height":34,"width":34,"blurWidth":0,"blurHeight":0};